<template>
  <validation-provider
    :rules="_rules"
    :name="columnInfo.domainColumnName"
    v-slot="{ errors }"
  >
    <!-- validation-provider :name="columnInfo.label" -->
    <b-form-datepicker
      v-model="_value"
      size="sm"
      :disabled="columnInfo.disable() || disabled"
      :id="columnInfo.domainColumnName"
      :name="columnInfo.domainColumnName"
      :locale="locale"
      :start-weekday="weekday"
      :show-decade-nav="showDecadeNav"
      :hide-header="hideHeader"
      :date-format-options="{
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }"
      today-button
      reset-button
      close-button
    ></b-form-datepicker>
    <!-- class="mb-2" -->
    <span v-if="errorVisible" class="text-danger">
      {{ errors[0] }}
    </span>
  </validation-provider>
</template>

<script>
import { isNil } from 'lodash'

export default {
  name: 'BaseDateInput',

  inheritAttrs: false,

  data() {
    return {
      showDecadeNav: false,
      hideHeader: false,
      weekday: 0,
    }
  },

  props: {
    value: {
      type: String,
      default: '',
    },

    locale: {
      type: String,
      default: 'ja',
    },

    /**
     * 定義情報.
     * @type {Object}
     * @requires
     */
    columnInfo: {
      type: Object,
      required: true,
    },

    /**
     * 入力不可か.
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * バリデーションチェックの状態を表示するか.
     * @type {Boolean}
     */
    state: {
      type: Boolean,
      default: false,
    },

    /**
     * 入力検証ルール.
     * @type {String}
     */
    rules: {
      type: Array,
      default: () => [],
    },

    /**
     * エラーメッセージを表示するか.
     * @type {Boolean}
     */
    errorVisible: {
      type: Boolean,
      default: true,
    },

    rangeTarget: {
      type: String,
      default: null,
    },
  },

  computed: {
    _value: {
      get() {
        if (!isNil(this.value) && this.value.length == 8) {
          return this.$moment(this.value).format('YYYY-MM-DD')
        }
        return this.value ? this.value.replace(/\//g, '-') : this.value
      },

      set(v) {
        if (this.value !== v) this.$emit('input', v)
      },
    },

    /**
     * 入力検証ルール.
     * @return {String}
     */
    _rules() {
      let rules = ''
      this.rules.forEach((element) => {
        if (element == this.INPUT_TYPE_CHECK.REQUIRED) {
          rules += 'required|'
        }
        if (element == this.INPUT_TYPE_CHECK.DATETIMERANGE) {
          rules += `dateTimeRange:@${this.rangeTarget}|`
        }
        if (element == this.INPUT_TYPE_CHECK.DATERANGE) {
          rules += `dateRange:@${this.rangeTarget}|`
        }
      })
      return rules
    },
  },
}
</script>
